import { render, staticRenderFns } from "./validationtask-document-preview.vue?vue&type=template&id=9df05ca8"
import script from "./validationtask-document-preview.vue?vue&type=script&lang=js"
export * from "./validationtask-document-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports